import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  changeLoadFalse,
  closeForgetPassword,
  openRegisterPageFalse,
} from "../../actions";
import { useDispatch } from "react-redux";

export default function useLoginState() {
  const [passwordView, setPasswordView] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [forgetPassword, setforgetPassword] = useState(false);
  const isRegisterPage = useSelector((state) => state.openRegisterPage);
  const [isForgetPasswordSubmited, setisForgetPasswordSubmited] =
    useState(false);
  const forgetPasswordToggle = useSelector((state) => state.forgetPassword);
  const [userDetails, setUserDetails] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    let token = localStorage.getItem("gotasteClienttoken");
    if (token) {
      let decoded = jwtDecode(token);
      setUserDetails(decoded);
    }
  }, []);

  const hideModalInfo = () => {
    setLoginModalOpen(false);
    dispatch(changeLoadFalse());
    dispatch(openRegisterPageFalse());
    // window.$("#exampleModalCenter2").modal("hide");
  };

  const handleUserFound = () => {
    setPasswordView(true);
  };

  const showModalInfo = () => {
    setLoginModalOpen(true);
    dispatch(changeLoadFalse());
    dispatch(openRegisterPageFalse());
    // window.$("#exampleModalCenter2").modal("show");
  };

  return {
    userDetails,
    passwordView,
    setPasswordView,
    handleUserFound,
    loginModalOpen,
    setLoginModalOpen,
    forgetPassword,
    setforgetPassword,
    isRegisterPage,
    isForgetPasswordSubmited,
    setisForgetPasswordSubmited,
    forgetPasswordToggle,
    showModalInfo,
    hideModalInfo,
    closeForgetPassword,
    dispatch,
    openRegisterPageFalse,
  };
}
